module.exports = "https://coursera_assets.s3.amazonaws.com/images/92c4547dc4ee8b3cf2803fa0f315bd74.svg";